// Hilfsfunktion zum Umwandeln einer Cron-Expression in eine lesbare Form
export const  parseCronExpression = (cronExpression) => {

    let [second, minute, hour, dayOfMonth, month, dayOfWeek] = cronExpression.split(' ');
    if(minute.length == 1){
        minute = '0' + minute;
    }

    // Überprüfe verschiedene Szenarien basierend auf den Komponenten des Cron-Ausdrucks
    if (dayOfMonth === '*' && month === '*' && dayOfWeek === '?' && hour.includes('/')) {
        // Stündlich Modus (alle X Stunden ab einer bestimmten Uhrzeit)
        const interval = hour.split('/')[1];
        const startHour = hour.split('/')[0];
        return `Alle ${interval} Stunden ab ${startHour}:${minute} Uhr`;
    }

    if (dayOfMonth === '*' && month === '*' && dayOfWeek === '?' && minute.includes('*/')) {
        // Minütlich Modus (alle X Minuten)
        const interval = minute.split('*/')[1];
        return `Alle ${interval} Minuten`;
    }

    if (dayOfMonth === '*' && month === '*' && dayOfWeek === '?' && hour !== '*' && minute !== '*') {
        // Täglich Modus (jeden Tag zu einer bestimmten Uhrzeit)
        return `Jeden Tag um ${hour}:${minute} Uhr`;
    }

    if (dayOfMonth === '?' && month === '*' && dayOfWeek !== '*') {
        // Wochentags Modus (an bestimmten Wochentagen zu einer bestimmten Uhrzeit)
        const days = dayOfWeek.split(',').map(day => getDayName(day)).join(' und ');
        return `Jeden ${days} um ${hour}:${minute} Uhr`;
    }

    // Wenn der Ausdruck benutzerdefiniert ist und nicht erkannt wird
    return 'Benutzerdefinierter Cron-Ausdruck (' + cronExpression + ')';

    // Hilfsfunktion zur Umwandlung der Wochentagsnummer in einen Namen
    function getDayName(day: string): string {
        switch (day) {
            case '1': return 'Sonntag';
            case '2': return 'Montag';
            case '3': return 'Dienstag';
            case '4': return 'Mittwoch';
            case '5': return 'Donnerstag';
            case '6': return 'Freitag';
            case '7': return 'Samstag';
            default: return '';
        }
    }
};